import * as React from 'react';
import { Fade, Tooltip } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip';

/**
 * HelpTooltip — a styled Tooltip using the application help visual theme.
 * Drop-in replacement for MUI Tooltip with dark blue background, blue left border, fade transition.
 */
const HelpTooltip: React.FC<TooltipProps> = ({ children, slots, slotProps, ...props }) => {
    return (
        <Tooltip
            arrow
            enterDelay={200}
            leaveDelay={0}
            {...props}
            slots={{ transition: Fade, ...slots }}
            slotProps={{
                ...slotProps,
                transition: { timeout: 300, ...(slotProps?.transition as object) },
                tooltip: {
                    ...slotProps?.tooltip,
                    sx: {
                        bgcolor: 'rgba(13, 35, 58, 0.97)',
                        color: 'white',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(100,181,246,0.25)',
                        borderLeft: '3px solid #42a5f5',
                        borderRadius: '4px',
                        fontSize: '0.875rem',
                        maxWidth: 450,
                        p: 1.75,
                        '& .MuiTooltip-arrow': {
                            color: 'rgba(13, 35, 58, 0.97)',
                        },
                        ...(slotProps?.tooltip as { sx?: object })?.sx,
                    },
                },
            }}
        >
            {children}
        </Tooltip>
    );
};

export default HelpTooltip;
